import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import JsonCollapse from "../JsonCollapse";
import UsedInLink from "../UsedInLink";
import BusinessHoursForm from "../BusinessHoursForm";
import {
  addNewBusinessHours,
  selectInputArguments,
  selectBusinessHours,
  setBusinessHours as setBH,
} from "../../../store/slices/projectSlice";

export default function BusinessHours() {
  const navigate = useNavigate();
  const params = useParams();

  const businessHours = useSelector(
    selectBusinessHours(params.businessHoursUUID)
  );
  const inputArguments = useSelector(selectInputArguments);
  const dispatch = useDispatch();

  const setBusinessHours = (fn) => dispatch(setBH(fn(businessHours)));

  const location = useLocation();
  const handleClose = () => {
    if (businessHours?.Label) {
      navigate(location.state?.nextPage || `/library/logic/builder/${params.projectID}`);
    } else {
      toast.error("Label is missing!");
    }
  };

  useEffect(() => {
    // set businessHours when the window shows
    if (params.businessHoursUUID) {
      if (params.businessHoursUUID === "create_new") {
        const newBHUUID = uuidv4();
        dispatch(addNewBusinessHours({ UUID: newBHUUID }));
        navigate(`/library/logic/builder/${params.projectID}/business-hours/${newBHUUID}`, {
          replace: true,
        });
      }
    }
  }, [params.businessHoursUUID]);

  return (
    <Modal
      size="xl"
      centered
      show={params.businessHoursUUID && businessHours}
      onHide={handleClose}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          {params.businessHoursUUID === "create_new" ? "Create " : "Edit "}
          business hours
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BusinessHoursForm
          value={businessHours}
          onChange={(nextBusinessHours) => setBusinessHours(() => nextBusinessHours)}
          showLabel
          variableOptions={inputArguments
            .filter((arg) => arg.Format === "business-hours")
            .map((arg) => ({
              value: arg.UUID,
              label: arg.Label,
            }))}
          conditionVariableOptions={inputArguments
            .filter((arg) => arg.Format === "short-text")
            .map((arg) => ({
              value: arg.UUID,
              label: arg.Label,
            }))}
        />

        <UsedInLink arg={businessHours} />
        <JsonCollapse json={businessHours} />
      </Modal.Body>
    </Modal>
  );
}
